/**
 * Backoff schedule for background-job result polling.
 *
 * Most background jobs complete within 1-3 seconds, but per-poll latency is
 * itself non-trivial (~1.3s p50 on geo-distant data planes). A constant
 * one-second poll wastes the first ~750ms on fast jobs and racks up
 * needless round-trips on slow ones. This schedule polls aggressively early
 * (250ms) to catch the common case, then doubles out and caps at 5s so a
 * stuck job doesn't keep hammering the API.
 *
 * Attempt index → poll interval before the next fetch (ms):
 *   0 → 250
 *   1 → 500
 *   2 → 1000
 *   3 → 2000
 *   4 → 3000
 *   5+ → 5000
 */
export function backoffPollIntervalMs(attempt: number): number {
  if (attempt <= 0) return 250;
  if (attempt === 1) return 500;
  if (attempt === 2) return 1000;
  if (attempt === 3) return 2000;
  if (attempt === 4) return 3000;
  return 5000;
}
